/* ============================================================
   BNDT SWEEPSTAKES PAGE JS
   ============================================================ */
(function () {
  'use strict';

  /* --- Countdown Timer --- */
  function initCountdown() {
    var boxes = document.querySelectorAll('.sweep-countdown__box');
    if (!boxes.length) return;

    // End date: 30 days from now (or set a fixed date)
    var endDateStr = document.querySelector('[data-sweep-end]');
    var endDate;
    if (endDateStr && endDateStr.getAttribute('data-sweep-end')) {
      endDate = new Date(endDateStr.getAttribute('data-sweep-end')).getTime();
    } else {
      endDate = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;
    }

    function update() {
      var now = new Date().getTime();
      var diff = endDate - now;

      if (diff <= 0) {
        boxes.forEach(function (box) {
          var num = box.querySelector('.sweep-countdown__num');
          if (num) num.textContent = '0';
        });
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      var vals = [days, hours, minutes, seconds];
      boxes.forEach(function (box, i) {
        var num = box.querySelector('.sweep-countdown__num');
        if (num && vals[i] !== undefined) {
          num.textContent = vals[i] < 10 ? '0' + vals[i] : vals[i];
        }
      });
    }

    update();
    setInterval(update, 1000);
  }

  /* --- Proof Ticker --- */
  function initTicker() {
    var track = document.querySelector('.sweep-ticker__track');
    if (!track) return;

    // Duplicate content for seamless loop
    var items = track.innerHTML;
    track.innerHTML = items + items;
  }

  /* --- Email Capture Validation --- */
  function initEmailCapture() {
    var form = document.querySelector('.sweep-capture__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var input = form.querySelector('input[type="email"]');
      var success = document.querySelector('.sweep-capture__success');
      var error = document.querySelector('.sweep-capture__error');

      if (!input || !input.value) return;

      var email = input.value.trim();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        if (error) {
          error.textContent = 'Please enter a valid email address.';
          error.style.display = 'block';
        }
        if (success) success.style.display = 'none';
        return;
      }

      // Submit to Shopify customer API
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email) + '&contact%5Btags%5D=sweep-50-entries'
      })
      .then(function () {
        if (success) {
          success.textContent = 'You\'re in! 50 bonus entries have been added to your account.';
          success.style.display = 'block';
        }
        if (error) error.style.display = 'none';
        input.value = '';
      })
      .catch(function () {
        if (error) {
          error.textContent = 'Something went wrong. Please try again.';
          error.style.display = 'block';
        }
      });
    });
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initTicker();
    initEmailCapture();
  });
})();
